import vuetify from './vuetify';
import { createI18n } from 'vue-i18n';
import messages from '@/utils/locales/messages';

// import pinia from '../stores'
import { createPinia } from 'pinia';
import { sentryPiniaPlugin } from './monitoring';
// import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import VueTablerIcons from 'vue-tabler-icons';
import VueApexCharts from 'vue3-apexcharts';
// import VCalendar from 'v-calendar';
// import Vue3EasyDataTable from 'vue3-easy-data-table';
// import Maska from 'maska';
// import print from 'vue3-print-nb';
// import VueRecaptcha from 'vue3-recaptcha-v2';
import { store, key } from '@/storeVuex';
// import CKEditor from '@ckeditor/ckeditor5-vue';
import VueEasyLightbox from 'vue-easy-lightbox';

const i18n = createI18n({
    locale: 'en',
    messages: messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true
});

export function registerPlugins(app) {
    app.use(vuetify)
        .use((() => {
            const pinia = createPinia();
            if (sentryPiniaPlugin) {
                pinia.use(sentryPiniaPlugin);
            }
            return pinia;
        })())
        .use(store)
        // .use(PerfectScrollbar)
        .use(VueTablerIcons as any)
        .use(VueApexCharts)
        // .use(VCalendar, {})
        // .component('EasyDataTable', Vue3EasyDataTable)
        .use(i18n)
        // .use(Maska)
        .use(VueEasyLightbox);
    // .use(CKEditor)
    // .use(print)
    // .use(VueRecaptcha, {
    //     siteKey: '6LdzqbcaAAAAALrGEZWQHIHUhzJZc8O-KSTdTTh_',
    //     alterDomain: false // default: false
    // })
}
